export default __webpack_public_path__ + "static/media/sc3.dbaa0638.png";